import { 
  Button, Modal, ModalBody, ModalHeader
} from "reactstrap";
import useModal from "hooks/useModal";
import Pdf from "./Pdf.js";

const PreviewPDF = ({ heading, isIb, t, fileUrl }) => {
  const [show, toggle] = useModal();
  return (
    <>
      <Button onClick={toggle} size="sm" color="primary" className="me-2">
        {t("Preview")}
      </Button>

      <Modal size="xl" toggle={toggle} isOpen={show}>
        <ModalHeader toggle={toggle}>{t("Preview Application")}</ModalHeader>

        <ModalBody>
          {fileUrl ? (
            <iframe
              src={fileUrl}
              width="100%"
              height="700px"
              style={{ border: "none" }}
              title="PDF Viewer"
            ></iframe>
          ) : (
            <>
              <Pdf heading={heading} isIb={isIb} />
            </>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default PreviewPDF;
